/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { SVGIcons } from "cms/icons/svg-icons";
import { isTrue } from "utils/empty-exists";

const UnderlineStyleLink = (props) => {

    const link = props?.link;
    const style = props?.style;
    const isExternal = isTrue(link?.is_external);
    const internalNewTab = link?.new_tab ?? false;
    const openInNewTab = isExternal || internalNewTab;
    const target = openInNewTab ? "_blank" : "_self";

    return (
        <a
            href={link?.url}
            className={`displayLink ${style} `}
            target={target}
            rel='noreferrer'
        >
            {link.text}
            {isExternal &&
                <>{" "}<SVGIcons.fields.LinkField /></>
            }
        </a>
    );
};

export { UnderlineStyleLink };
